import { render } from "./PHome.vue?vue&type=template&id=55e31757&scoped=true"
import script from "./PHome.vue?vue&type=script&lang=js"
export * from "./PHome.vue?vue&type=script&lang=js"

import "./PHome.vue?vue&type=style&index=0&id=55e31757&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e31757"]])

export default __exports__